"use strict";
import { __exports as e } from "./index.es480.js";
var i;
function u() {
  return i ? e : (i = 1, (function(r) {
    Object.defineProperty(r, "__esModule", {
      value: !0
    }), Object.defineProperty(r, "removeTrailingSlash", {
      enumerable: !0,
      get: function() {
        return n;
      }
    });
    function n(a) {
      return a.replace(/\/$/, "") || "/";
    }
  })(e), e);
}
export {
  u as __require
};
//# sourceMappingURL=index.es444.js.map
